import styled from 'styled-components';
import { device } from '../../styles/devices';

export const ButtonWrapper = styled.div<{
  isVisible: boolean;
  color: string;
  isNew: boolean;
  isT3: boolean;
}>`
  display: inline-block;
  visibility: ${({ isVisible }) => (!isVisible ? 'hidden' : 'visible')};
  margin-top: ${({ isNew }) => (!isNew ? '20px' : '32px')};
  padding-bottom: ${({ isNew, isT3 }) => (isT3 && isNew ? '0px' : '32px')};

  @media ${device.tablet} {
    padding-bottom: ${({ isNew, isT3 }) => (isT3 || !isNew ? '0px' : '32px')};
  }

  button {
    display: ${({ isVisible }) => (!isVisible ? 'none' : 'inline-block')};
    visibility: hidden;
    z-index: 1;
    color: ${({ color }) => `${color} !important`};

    &:hover {
      color: ${({ color }) => (color === '#ffffff' ? '#b3b3b3 !important' : '#4c4c4c !important')};
    }
  }

  span {
    display: flex;
    justify-content: space-between;
  }
`;

export const IconWrapper = styled.div<{
  color: string;
}>`
  svg {
    margin-right: 1em;
    fill: none;

    path {
      transition-duration: 250ms;
    }

    path:nth-child(4) {
      fill: ${({ color }) => `${color}`};
      ${ButtonWrapper}:hover & {
        transition-duration: 250ms;
        fill: ${({ color }) => (color === '#ffffff' ? '#b3b3b3' : '#4c4c4c')};
      }
    }

    path:nth-child(5) {
      stroke: ${({ color }) => `${color}`};
      ${ButtonWrapper}:hover & {
        transition-duration: 250ms;
        stroke: ${({ color }) => (color === '#ffffff' ? '#b3b3b3' : '#4c4c4c')};
      }
    }
  }
`;
